import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import closePng from 'images/close.png';
import './VideoReact.css';
import './VideoModal.css';
import { Player } from 'video-react';

class VideoModal extends Component {
  static propTypes = {
    autoPlay: PropTypes.bool,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
  };

  static defaultProps = {
    autoPlay: false,
  };

  handleClose = () => {
    if (this.props.onHide) {
      this.props.onHide();
    }
  };

  render() {
    return (
      <div className="video-modal-container">
        <Modal show={this.props.show} className="video-modal">
          <Modal.Header>
            <span className="close-icon">
              <img src={closePng} alt="close" onClick={this.handleClose} />
            </span>
          </Modal.Header>

          <Modal.Body>
            <Player
              playsInline
              autoPlay={this.props.autoPlay}
              src={this.props.videoSrc}
            />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default VideoModal;



// WEBPACK FOOTER //
// ./src/components/shared/modal/VideoModal.js